// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cwVa","rootNoMargin":"styles_rootNoMargin__1qzSx"};